// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
export enum LinkedPriceType {
    None,
    Bid,
    Ask,
    Last
}
